const NOT_SUPPORTED_MESSAGE = '복사하기가 지원되지 않는 브라우저입니다.';

const copyToClipboard = async (
  text: string,
  alertMessage = '클립보드에 복사되었습니다.'
) => {
  const isDisabledClipboard =
    !navigator.clipboard || !navigator.clipboard.writeText;

  if (isDisabledClipboard) {
    alert(NOT_SUPPORTED_MESSAGE);

    return;
  }

  try {
    await navigator.clipboard.writeText(text);
    alert(alertMessage);
  } catch (error) {
    alert(NOT_SUPPORTED_MESSAGE);
  }
};

export default copyToClipboard;
